import { compose } from 'recompose';
import { connect } from 'react-redux';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import {
  selectUserDetailsPending,
  selectProgressServicesByVisit,
} from '../../../redux/appointmentForm/selectors';
import withUserDetails from '../hocs/withUserDetails';

const mapStateToProps = state => ({
  loading: selectUserDetailsPending(state),
  services: selectProgressServicesByVisit(state),
});

const mapDispatchToProps = {
  inspectPatient: appointmentProgressActions.inspectPatient,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withUserDetails,
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPatientInfo/enhance.js